/* eslint-disable no-unused-vars */
// redux/claimSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance9000 } from "../../../api/axiosInstance";

export const fetchAllClaim = createAsyncThunk(
  "allClaim/fetchClaimAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance9000.get("/api/headoffice/claim/report/list");
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const allClaimSlice = createSlice({
  name: "allClaim",
  initialState: {
    allClaims: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllClaim.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllClaim.fulfilled, (state, action) => {
        state.loading = false;
        state.allClaims = action.payload;
      })
      .addCase(fetchAllClaim.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default allClaimSlice.reducer;
